import type { CurrentBannerPosition } from "./current-banner-position.types";

export const currentBannerPosition = { value: null as CurrentBannerPosition };
